// const AppDetailHeader = r => require.ensure([], () => r(require('./AppDetailHeader.vue')), 'appdetailheader-chunk')
import AppDetailHeader from './AppDetailHeader'

export default AppDetailHeader
